import {Component} from 'react'
import {connect} from 'react-redux'
import {renderRoutes} from 'react-router-config'
import { isEqual } from '../../../shared/services/lodashInJS.js'
import PropTypes from 'prop-types'

import queryWatcher from '../../components/QueryWatcher/QueryWatcherConnect.js'
import {isAdmin} from '../../../shared/services/userService.js'
import withCurrentUniverse, {CURRENT_USER_PRIORITY} from '../../HOC/withCurrentUniverse.jsx'

import './Search.scss'

class SearchContainer extends Component {
  static propTypes = {
    dispatchSearch: PropTypes.func.isRequired,
    expandSearchObject: PropTypes.func.isRequired,
    flattenOffer: PropTypes.func,
    flattenSearchObject: PropTypes.func.isRequired,
    liftOffer: PropTypes.func,
    search: PropTypes.func.isRequired,
    routes: PropTypes.array,
    searchRouteName: PropTypes.string.isRequired,
    searchTarget: PropTypes.string.isRequired,
  }

  static defaultProps = {
    flattenOffer: () => {},
    liftOffer: () => {},
    routes: []
  }

  componentDidMount() {
    const queryExpanded = this.props.expandSearchObject(this.props.queryString, this.props?.currentUniverse.id ?? null)
    if (!isEqual(this.props.searchData.search, queryExpanded)) {
      this.loadSearch(queryExpanded)
    }
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    const queryExpanded = this.props.expandSearchObject(this.props.queryString, this.props?.currentUniverse.id ?? null)

    if ((this.props.location.pathname !== prevProps.location.pathname) || (this.props.location.search !== prevProps.location.search)) {
      this.loadSearch(queryExpanded)
    }

    if (!this.props.searchData.loading && !isEqual(this.props.searchData.search, queryExpanded)) {
      this.loadSearch(queryExpanded)
    }
  }

  loadSearch = (search) => {
    if (search?.universe) {
      this.props.dispatchSearch(search)
        .catch(console.warn)

    }
  }

  render() {
    const {searchData, searchTarget} = this.props

    const searchQuery = this.props.expandSearchObject(this.props.queryString, this.props?.currentUniverse.id ?? null)
    const loading = searchData.loading || !searchData.endSearch || searchTarget !== searchData.search.target

    return (
      renderRoutes(this.props.routes, {
        currentUser: this.props.currentUser,
        flattenOffer: this.props.flattenOffer,
        flattenSearchObject: this.props.flattenSearchObject,
        isAdmin: this.props.isAdmin,
        liftOffer: this.props.liftOffer,
        loading: loading,
        loadSearch: this.loadSearch,
        search: (data) => this.props.search({...searchQuery, ...data}),
        searchQuery: searchQuery,
        searchRouteName: this.props.searchRouteName,
        searchTarget: searchTarget,
      })
    )
  }
}

export default queryWatcher(connect(
  (state) => ({
    currentUniverse: state?.universe.currentUniverse ?? null,
    currentUser: state.currentUser.user,
    isAdmin: isAdmin(state.currentUser.user, state.universe.currentUniverse),
    searchData: state.search,
  }),
)(withCurrentUniverse(SearchContainer, CURRENT_USER_PRIORITY)))